'use client';
import { useState, useMemo } from 'react';
import { useIsomorphicLayoutEffect } from '../use-isomorphic-layout-effect.js';
import { ROOT_CLASSNAMES } from '../../../core/constants/globals.js';

function hasStandardModeEnabled(e) {
    return null != e && !!e.className.includes(ROOT_CLASSNAMES.standardMode);
}
function hasNestedStandardMode(e, t) {
    let r = null == e ? void 0 : e.parentElement;
    for(; r && r !== t;){
        if (hasStandardModeEnabled(r)) return true;
        r = r.parentElement;
    }
    return false;
}
function setMode(e, t, o) {
    if (hasStandardModeEnabled(e.current)) t(false);
    else {
        var d;
        let n = null === (d = e.current) || void 0 === d ? void 0 : d.closest(`.${ROOT_CLASSNAMES[o]}`);
        t(!!n && !hasNestedStandardMode(e.current, n));
    }
}
function useModeExtractor(r, d) {
    let [n, a] = useState(false), [s, c] = useState(false);
    return useIsomorphicLayoutEffect(()=>{
        setMode(r, a, 'darkMode'), setMode(r, c, 'compactMode');
    }, [
        r,
        d
    ]), useMemo(()=>({
            hasDarkMode: n,
            hasCompactMode: s
        }), [
        n,
        s
    ]);
}

export { hasNestedStandardMode, useModeExtractor };
